import { takeEvery } from 'redux-saga/effects'
import { SOCKET_CLIENT_WAITING, SOCKET_CLIENT_QUEUED } from 'src/store/types/chatData'
import fetchNewGroupFromSocket from './fetchNewGroupFromSocket'

export function* chatDataUpdate() {
  yield takeEvery(SOCKET_CLIENT_WAITING, fetchNewGroupFromSocket)
  yield takeEvery(SOCKET_CLIENT_QUEUED, fetchNewGroupFromSocket)
}
